"use strict";

var _regeneratorRuntime = require("/Users/davidx/projects/unishell/wallet/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Users/davidx/projects/unishell/wallet/node_modules/@babel/runtime/helpers/asyncToGenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var types_1 = require("../types");

function findPlaceholderLink(doc, href) {
  var result;

  function findLinks(node) {
    var pos = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

    if (node.type.name === "text") {
      node.marks.forEach(function (mark) {
        if (mark.type.name === "link") {
          if (mark.attrs.href === href) {
            result = {
              node: node,
              pos: pos
            };
            if (result) return false;
          }
        }
      });
    }

    if (!node.content.size) {
      return;
    }

    node.descendants(findLinks);
  }

  findLinks(doc);
  return result;
}

var createAndInsertLink =
/*#__PURE__*/
function () {
  var _ref = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee(view, title, href, options) {
    var dispatch, state, onCreateLink, onShowToast, url, result, _result;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            dispatch = view.dispatch, state = view.state;
            onCreateLink = options.onCreateLink, onShowToast = options.onShowToast;
            _context.prev = 2;
            _context.next = 5;
            return onCreateLink(title);

          case 5:
            url = _context.sent;
            result = findPlaceholderLink(view.state.doc, href);

            if (result) {
              _context.next = 9;
              break;
            }

            return _context.abrupt("return");

          case 9:
            dispatch(view.state.tr.removeMark(result.pos, result.pos + result.node.nodeSize, state.schema.marks.link).addMark(result.pos, result.pos + result.node.nodeSize, state.schema.marks.link.create({
              href: url
            })));
            _context.next = 19;
            break;

          case 12:
            _context.prev = 12;
            _context.t0 = _context["catch"](2);
            _result = findPlaceholderLink(view.state.doc, href);

            if (_result) {
              _context.next = 17;
              break;
            }

            return _context.abrupt("return");

          case 17:
            dispatch(view.state.tr.removeMark(_result.pos, _result.pos + _result.node.nodeSize, state.schema.marks.link));

            if (onShowToast) {
              onShowToast(options.dictionary.createLinkError, types_1.ToastType.Error);
            }

          case 19:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[2, 12]]);
  }));

  return function createAndInsertLink(_x, _x2, _x3, _x4) {
    return _ref.apply(this, arguments);
  };
}();

exports.default = createAndInsertLink;